import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';

//Componentes
import DJCPSearchContainer from '../../components/DJCPSearch/DJCPSearchContainer';
import DJCESearchContainer from '../../components/DJCESearch/DJCESearchContainer';
import DJTVSearchContainer from '../../components/DJTVSearch/DJTVSearchContainer';
import DJCVSearchContainer from '../../components/DJCVSearch/DJCVSearchContainer';
import DJDUVSearchContainer from '../../components/DJDUVSearch/DJDUVSearchContainer';
import DJMVSearchContainer from '../../components/DJMVSearch/DJMVSearchContainer';

//Estilos
import './SearchDeclaraciones.css';

function SearchDeclaraciones({ states, functions }) {
    const { masters, localeDateFormat, SearchParameters } = states;

    const {
        control,
        getValues,
        setValue,
        register,
        watch,
        handleSubmit,
        formState: { errors },
        onSearch,
    } = functions;

    return (
        <div className="search_declaraciones-container">
            <section className="search_declaraciones-section">
                <h4>Filtro de Búsqueda</h4>
                <form
                    className="search_declaraciones-search_form"
                    onSubmit={handleSubmit(onSearch)}
                >
                    <label className="search_declaraciones-label">
                        <span>Serie: </span>
                        <input
                            className="search_declaraciones-input"
                            type="number"
                            {...register('serie')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 15
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="search_declaraciones-label">
                        <span>Titular: </span>
                        <input
                            className="search_declaraciones-input"
                            type="text"
                            {...register('titular')}
                        />
                    </label>
                    <label className="search_declaraciones-label">
                        <span>Fecha Inicio: </span>
                        <Controller
                            name="fecha_Inicial"
                            control={control}
                            render={() => (
                                <ReactDatePicker
                                    dateFormat={'dd/MM/yyyy'}
                                    isClearable
                                    placeholderText="dd/mm/aaaa"
                                    locale={localeDateFormat}
                                    selected={getValues('fecha_Inicial')}
                                    onChange={(date) =>
                                        setValue('fecha_Inicial', date)
                                    }
                                />
                            )}
                            rules={{
                                validate: {
                                    validDate: (v) =>
                                        !v ||
                                        (v && !watch('fecha_Final')) ||
                                        new Date(v) <=
                                            new Date(watch('fecha_Final')) ||
                                        'La fecha inicial debe ser menor o igual a la final',
                                },
                            }}
                        />
                        {errors.fecha_Inicial && (
                            <small className="form__error">
                                {errors.fecha_Inicial?.message}
                            </small>
                        )}
                    </label>
                    <label className="search_declaraciones-label">
                        <span>Fecha Fin: </span>
                        <Controller
                            name="fecha_Final"
                            control={control}
                            render={() => (
                                <ReactDatePicker
                                    dateFormat={'dd/MM/yyyy'}
                                    isClearable
                                    placeholderText="dd/mm/aaaa"
                                    locale={localeDateFormat}
                                    selected={getValues('fecha_Final')}
                                    onChange={(date) =>
                                        setValue('fecha_Final', date)
                                    }
                                />
                            )}
                            rules={{
                                validate: {
                                    validDate: (v) =>
                                        !v ||
                                        (v && !watch('fecha_Inicial')) ||
                                        new Date(v) >=
                                            new Date(watch('fecha_Inicial')) ||
                                        'La fecha final debe ser mayor o igual a la inicial',
                                },
                            }}
                        />
                        {errors.fecha_Final && (
                            <small className="form__error">
                                {errors.fecha_Final?.message}
                            </small>
                        )}
                    </label>
                    <label className="search_declaraciones-label">
                        <span>Departamento: </span>
                        <select {...register('departamento')}>
                            <option value={0}>Cualquiera</option>
                            {masters?.Departments?.map((d) => {
                                return (
                                    <option key={d.id} value={d.id}>
                                        {d.nombre.replaceAll('_', ' ')}
                                    </option>
                                );
                            })}
                        </select>
                    </label>
                    <label className="search_declaraciones-label">
                        <span>Seccional: </span>
                        <input
                            type="number"
                            {...register('seccional')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 2
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="search_declaraciones-label">
                        <span>Viñedo: </span>
                        <input
                            type="number"
                            {...register('viniedo')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 15
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <div className="search_declaraciones-label check-label">
                        <span>Tipo Declaración: </span>
                        <div>
                            {masters?.ObjectTypes?.map((d, i) => {
                                if ([4, 5, 6, 7, 8, 9].includes(d.id))
                                    return (
                                        <label key={d.id}>
                                            <input
                                                className="search_declaraciones-checkbox"
                                                type="checkbox"
                                                {...register(`tipo[${i}]`)}
                                                value={d.id}
                                                defaultChecked
                                            />
                                            <span>
                                                {d.nombre.replaceAll('_', ' ')}
                                            </span>
                                        </label>
                                    );
                            })}
                        </div>
                    </div>
                    <div className="search_declaraciones-form-footer">
                        <button className="btn btn-primary" type="submit">
                            Buscar
                        </button>
                    </div>
                </form>
            </section>
            <section className="search_declaraciones-section">
                {SearchParameters?.declaraciones?.tipo?.map((dt, i) => {
                    switch (parseInt(dt)) {
                        case 4:
                            return <DJCPSearchContainer key={`table${i}`} />;
                        case 5:
                            return <DJCESearchContainer key={`table${i}`} />;
                        case 6:
                            return <DJTVSearchContainer key={`table${i}`} />;
                        case 7:
                            return <DJCVSearchContainer key={`table${i}`} />;
                        case 8:
                            return <DJDUVSearchContainer key={`table${i}`} />;
                        case 9:
                            return <DJMVSearchContainer key={`table${i}`} />;

                        default:
                            return;
                    }
                })}
                {/* {DeclaracionesList.length > 0 &&
                    tableData?.map((t, i) => {
                        if (t.data.length > 0)
                            return (
                                <TableContainer
                                    key={`table-${i}`}
                                    tableData={t}
                                />
                            );
                    })} */}
            </section>
        </div>
    );
}

export default SearchDeclaraciones;
